import { BscEjercicioKpi, SemaforoBsc } from "src/app/shared/model/bsc/bsc.model";
import { numero } from "./bsc-formato";

/**
 * BSC (FOR-011): los campos por trimestre de un KPI del año
 * (BscEjercicioKpi: aplicaQ1..Q4, pesoQ1..Q4 y los calculados K, L, N y
 * semáforo) leídos por número de trimestre, sin índices por texto. Funciones
 * puras para A2 y A3 (F4.3).
 */

/** Si el KPI aplica en el trimestre q (1..4); nulo = aplica (DEFAULT 1). */
export function aplicaEn(k: BscEjercicioKpi, q: number): boolean {
  const valores = [k.aplicaQ1, k.aplicaQ2, k.aplicaQ3, k.aplicaQ4];
  return valores[q - 1] !== false;
}

/** M del FOR-011: el peso del trimestre, fracción. */
export function pesoEn(k: BscEjercicioKpi, q: number): number | null {
  return numero([k.pesoQ1, k.pesoQ2, k.pesoQ3, k.pesoQ4][q - 1]);
}

/** K del FOR-011: real × peso / programado. */
export function ponderadoEn(k: BscEjercicioKpi, q: number): number | null {
  return numero([k.ponderadoQ1, k.ponderadoQ2, k.ponderadoQ3, k.ponderadoQ4][q - 1]);
}

/** L del FOR-011: el ponderado acumulado. */
export function acumRealEn(k: BscEjercicioKpi, q: number): number | null {
  return numero([k.acumRealQ1, k.acumRealQ2, k.acumRealQ3, k.acumRealQ4][q - 1]);
}

/** N del FOR-011: el peso acumulado (lo programado). */
export function acumProgEn(k: BscEjercicioKpi, q: number): number | null {
  return numero([k.acumProgQ1, k.acumProgQ2, k.acumProgQ3, k.acumProgQ4][q - 1]);
}

/** El semáforo calculado del KPI en el trimestre q. */
export function semaforoEn(k: BscEjercicioKpi, q: number): SemaforoBsc | null {
  return [k.semaforoQ1, k.semaforoQ2, k.semaforoQ3, k.semaforoQ4][q - 1] ?? null;
}
